/**
 * ORD Distribution Center
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { BulkCreateFrontPlateOrders } from '../model/bulkCreateFrontPlateOrders';
// @ts-ignore
import { CreateFrontPlateOrder } from '../model/createFrontPlateOrder';
// @ts-ignore
import { CreateFrontPlateOrderForRegistration } from '../model/createFrontPlateOrderForRegistration';
// @ts-ignore
import { FrontPlateOrder } from '../model/frontPlateOrder';
// @ts-ignore
import { FrontPlateOrderDeliveryPoint } from '../model/frontPlateOrderDeliveryPoint';
// @ts-ignore
import { FrontPlateOrderDossierManager } from '../model/frontPlateOrderDossierManager';
// @ts-ignore
import { FrontPlateOrderStatistics } from '../model/frontPlateOrderStatistics';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';


export interface BulkCreateFrontPlateOrdersRequestParams {
    /** Logged-in user number */
    X_WSS_rs_user_number: string;
    request?: BulkCreateFrontPlateOrders;
    /** Binary part in multipart request. BLOB should be sent. Max. 5MB allowed. */
    file?: Blob;
}

export interface CreateFrontPlateOrderRequestParams {
    /** Logged-in user number */
    X_WSS_rs_user_number: string;
    CreateFrontPlateOrder?: CreateFrontPlateOrder;
}

export interface CreateFrontPlateOrderForRegistrationRequestParams {
    /** Logged-in user number */
    X_WSS_rs_user_number: string;
    CreateFrontPlateOrderForRegistration?: CreateFrontPlateOrderForRegistration;
}

export interface ExportFrontPlateOrderRequestParams {
    /** Logged-in user number */
    X_WSS_rs_user_number: string;
    licensePlate?: string;
    dossierManager?: number;
    deliveryPoint?: string;
    sendDateFrom?: string;
    sendDateTo?: string;
    status?: Array<'ACCEPTED' | 'ORDERED'>;
    _sortBy?: 'FOLLOW_UP' | 'LICENSE_PLATE' | 'SEND_DATE';
    _sortDirection?: 'ASC' | 'DESC';
}

export interface GetDeliveryPointsRequestParams {
    /** Logged-in user number */
    X_WSS_rs_user_number: string;
}

export interface GetDossierManagersRequestParams {
    /** Logged-in user number */
    X_WSS_rs_user_number: string;
}

export interface GetFrontPlateOrderRequestParams {
    /** Logged-in user number */
    X_WSS_rs_user_number: string;
    _page?: number;
    _pageSize?: number;
    licensePlate?: string;
    dossierManager?: number;
    deliveryPoint?: string;
    sendDateFrom?: string;
    sendDateTo?: string;
    status?: Array<'ACCEPTED' | 'ORDERED'>;
    _sortBy?: 'FOLLOW_UP' | 'LICENSE_PLATE' | 'SEND_DATE';
    _sortDirection?: 'ASC' | 'DESC';
}

export interface GetFrontPlateOrderStatisticsRequestParams {
    /** leasing company rs number */
    rsNumber: number;
    date: string;
}


@Injectable({
  providedIn: 'root'
})
export class FrontPlateOrderService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Bulk create front plate orders
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bulkCreateFrontPlateOrders(requestParameters: BulkCreateFrontPlateOrdersRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<FrontPlateOrder>>;
    public bulkCreateFrontPlateOrders(requestParameters: BulkCreateFrontPlateOrdersRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<FrontPlateOrder>>>;
    public bulkCreateFrontPlateOrders(requestParameters: BulkCreateFrontPlateOrdersRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<FrontPlateOrder>>>;
    public bulkCreateFrontPlateOrders(requestParameters: BulkCreateFrontPlateOrdersRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const X_WSS_rs_user_number = requestParameters?.X_WSS_rs_user_number;
        if (X_WSS_rs_user_number === null || X_WSS_rs_user_number === undefined) {
            throw new Error('Required parameter X_WSS_rs_user_number was null or undefined when calling bulkCreateFrontPlateOrders.');
        }
        const request = requestParameters?.request;
        const file = requestParameters?.file;

        let localVarHeaders = this.defaultHeaders;
        if (X_WSS_rs_user_number !== undefined && X_WSS_rs_user_number !== null) {
            localVarHeaders = localVarHeaders.set('X-WSS-rs-user-number', String(X_WSS_rs_user_number));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (request !== undefined) {
            localVarFormParams = localVarFormParams.append('request', localVarUseForm ? new Blob([JSON.stringify(request)], {type: 'application/json'}) : <any>request) as any || localVarFormParams;
        }
        if (file !== undefined) {
            localVarFormParams = localVarFormParams.append('file', <any>file) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/front-plate-order/bulk`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<FrontPlateOrder>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a front plate order
     * Create a new front plate order
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createFrontPlateOrder(requestParameters: CreateFrontPlateOrderRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FrontPlateOrder>;
    public createFrontPlateOrder(requestParameters: CreateFrontPlateOrderRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FrontPlateOrder>>;
    public createFrontPlateOrder(requestParameters: CreateFrontPlateOrderRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FrontPlateOrder>>;
    public createFrontPlateOrder(requestParameters: CreateFrontPlateOrderRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const X_WSS_rs_user_number = requestParameters?.X_WSS_rs_user_number;
        if (X_WSS_rs_user_number === null || X_WSS_rs_user_number === undefined) {
            throw new Error('Required parameter X_WSS_rs_user_number was null or undefined when calling createFrontPlateOrder.');
        }
        const CreateFrontPlateOrder = requestParameters?.CreateFrontPlateOrder;

        let localVarHeaders = this.defaultHeaders;
        if (X_WSS_rs_user_number !== undefined && X_WSS_rs_user_number !== null) {
            localVarHeaders = localVarHeaders.set('X-WSS-rs-user-number', String(X_WSS_rs_user_number));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/front-plate-order`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FrontPlateOrder>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: CreateFrontPlateOrder,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a front plate order for a registration
     * Create a new front plate order for a registration
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createFrontPlateOrderForRegistration(requestParameters: CreateFrontPlateOrderForRegistrationRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FrontPlateOrder>;
    public createFrontPlateOrderForRegistration(requestParameters: CreateFrontPlateOrderForRegistrationRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FrontPlateOrder>>;
    public createFrontPlateOrderForRegistration(requestParameters: CreateFrontPlateOrderForRegistrationRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FrontPlateOrder>>;
    public createFrontPlateOrderForRegistration(requestParameters: CreateFrontPlateOrderForRegistrationRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const X_WSS_rs_user_number = requestParameters?.X_WSS_rs_user_number;
        if (X_WSS_rs_user_number === null || X_WSS_rs_user_number === undefined) {
            throw new Error('Required parameter X_WSS_rs_user_number was null or undefined when calling createFrontPlateOrderForRegistration.');
        }
        const CreateFrontPlateOrderForRegistration = requestParameters?.CreateFrontPlateOrderForRegistration;

        let localVarHeaders = this.defaultHeaders;
        if (X_WSS_rs_user_number !== undefined && X_WSS_rs_user_number !== null) {
            localVarHeaders = localVarHeaders.set('X-WSS-rs-user-number', String(X_WSS_rs_user_number));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/front-plate-order/registration`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FrontPlateOrder>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: CreateFrontPlateOrderForRegistration,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export all selected front plate orders
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public exportFrontPlateOrder(requestParameters: ExportFrontPlateOrderRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.ms-excel', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public exportFrontPlateOrder(requestParameters: ExportFrontPlateOrderRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.ms-excel', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public exportFrontPlateOrder(requestParameters: ExportFrontPlateOrderRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/vnd.ms-excel', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public exportFrontPlateOrder(requestParameters: ExportFrontPlateOrderRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/vnd.ms-excel', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const X_WSS_rs_user_number = requestParameters?.X_WSS_rs_user_number;
        if (X_WSS_rs_user_number === null || X_WSS_rs_user_number === undefined) {
            throw new Error('Required parameter X_WSS_rs_user_number was null or undefined when calling exportFrontPlateOrder.');
        }
        const licensePlate = requestParameters?.licensePlate;
        const dossierManager = requestParameters?.dossierManager;
        const deliveryPoint = requestParameters?.deliveryPoint;
        const sendDateFrom = requestParameters?.sendDateFrom;
        const sendDateTo = requestParameters?.sendDateTo;
        const status = requestParameters?.status;
        const _sortBy = requestParameters?._sortBy;
        const _sortDirection = requestParameters?._sortDirection;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>licensePlate, 'licensePlate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dossierManager, 'dossierManager');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deliveryPoint, 'deliveryPoint');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sendDateFrom, 'sendDateFrom');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sendDateTo, 'sendDateTo');
        if (status) {
            status.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'status');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>_sortBy, '_sortBy');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>_sortDirection, '_sortDirection');

        let localVarHeaders = this.defaultHeaders;
        if (X_WSS_rs_user_number !== undefined && X_WSS_rs_user_number !== null) {
            localVarHeaders = localVarHeaders.set('X-WSS-rs-user-number', String(X_WSS_rs_user_number));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/vnd.ms-excel'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/front-plate-order/export`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all delivery points who have received front plates in the past
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDeliveryPoints(requestParameters: GetDeliveryPointsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<FrontPlateOrderDeliveryPoint>>;
    public getDeliveryPoints(requestParameters: GetDeliveryPointsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<FrontPlateOrderDeliveryPoint>>>;
    public getDeliveryPoints(requestParameters: GetDeliveryPointsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<FrontPlateOrderDeliveryPoint>>>;
    public getDeliveryPoints(requestParameters: GetDeliveryPointsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const X_WSS_rs_user_number = requestParameters?.X_WSS_rs_user_number;
        if (X_WSS_rs_user_number === null || X_WSS_rs_user_number === undefined) {
            throw new Error('Required parameter X_WSS_rs_user_number was null or undefined when calling getDeliveryPoints.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (X_WSS_rs_user_number !== undefined && X_WSS_rs_user_number !== null) {
            localVarHeaders = localVarHeaders.set('X-WSS-rs-user-number', String(X_WSS_rs_user_number));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/front-plate-order/delivery-point`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<FrontPlateOrderDeliveryPoint>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all dossier managers who have created front plate orders in the past
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDossierManagers(requestParameters: GetDossierManagersRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<FrontPlateOrderDossierManager>>;
    public getDossierManagers(requestParameters: GetDossierManagersRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<FrontPlateOrderDossierManager>>>;
    public getDossierManagers(requestParameters: GetDossierManagersRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<FrontPlateOrderDossierManager>>>;
    public getDossierManagers(requestParameters: GetDossierManagersRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const X_WSS_rs_user_number = requestParameters?.X_WSS_rs_user_number;
        if (X_WSS_rs_user_number === null || X_WSS_rs_user_number === undefined) {
            throw new Error('Required parameter X_WSS_rs_user_number was null or undefined when calling getDossierManagers.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (X_WSS_rs_user_number !== undefined && X_WSS_rs_user_number !== null) {
            localVarHeaders = localVarHeaders.set('X-WSS-rs-user-number', String(X_WSS_rs_user_number));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/front-plate-order/dossier-manager`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<FrontPlateOrderDossierManager>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all front plate orders
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFrontPlateOrder(requestParameters: GetFrontPlateOrderRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<FrontPlateOrder>>;
    public getFrontPlateOrder(requestParameters: GetFrontPlateOrderRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<FrontPlateOrder>>>;
    public getFrontPlateOrder(requestParameters: GetFrontPlateOrderRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<FrontPlateOrder>>>;
    public getFrontPlateOrder(requestParameters: GetFrontPlateOrderRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const X_WSS_rs_user_number = requestParameters?.X_WSS_rs_user_number;
        if (X_WSS_rs_user_number === null || X_WSS_rs_user_number === undefined) {
            throw new Error('Required parameter X_WSS_rs_user_number was null or undefined when calling getFrontPlateOrder.');
        }
        const _page = requestParameters?._page;
        const _pageSize = requestParameters?._pageSize;
        const licensePlate = requestParameters?.licensePlate;
        const dossierManager = requestParameters?.dossierManager;
        const deliveryPoint = requestParameters?.deliveryPoint;
        const sendDateFrom = requestParameters?.sendDateFrom;
        const sendDateTo = requestParameters?.sendDateTo;
        const status = requestParameters?.status;
        const _sortBy = requestParameters?._sortBy;
        const _sortDirection = requestParameters?._sortDirection;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>_page, '_page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>_pageSize, '_pageSize');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>licensePlate, 'licensePlate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dossierManager, 'dossierManager');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deliveryPoint, 'deliveryPoint');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sendDateFrom, 'sendDateFrom');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sendDateTo, 'sendDateTo');
        if (status) {
            status.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'status');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>_sortBy, '_sortBy');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>_sortDirection, '_sortDirection');

        let localVarHeaders = this.defaultHeaders;
        if (X_WSS_rs_user_number !== undefined && X_WSS_rs_user_number !== null) {
            localVarHeaders = localVarHeaders.set('X-WSS-rs-user-number', String(X_WSS_rs_user_number));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/front-plate-order`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<FrontPlateOrder>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GET Statistics about front plate orders
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFrontPlateOrderStatistics(requestParameters: GetFrontPlateOrderStatisticsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FrontPlateOrderStatistics>;
    public getFrontPlateOrderStatistics(requestParameters: GetFrontPlateOrderStatisticsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FrontPlateOrderStatistics>>;
    public getFrontPlateOrderStatistics(requestParameters: GetFrontPlateOrderStatisticsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FrontPlateOrderStatistics>>;
    public getFrontPlateOrderStatistics(requestParameters: GetFrontPlateOrderStatisticsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const rsNumber = requestParameters?.rsNumber;
        if (rsNumber === null || rsNumber === undefined) {
            throw new Error('Required parameter rsNumber was null or undefined when calling getFrontPlateOrderStatistics.');
        }
        const date = requestParameters?.date;
        if (date === null || date === undefined) {
            throw new Error('Required parameter date was null or undefined when calling getFrontPlateOrderStatistics.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>date, 'date');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/front-plate-order/statistics/${this.configuration.encodeParam({name: "rsNumber", value: rsNumber, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FrontPlateOrderStatistics>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
